import * as React from "react";

import { UserWayWidget } from "components/integrations/userway/UserWayWidget";
import { ZendeskWidget } from "components/integrations/zendesk/ZendeskWidget";
import { WeglotLoader } from "lib/thirdparty/WeglotLoader";

export function ThirdPartyIntegrationLoader() {
  return (
    <React.Fragment>
      <ZendeskWidget />
      <UserWayWidget />
      <WeglotLoader />
    </React.Fragment>
  );
}
